module.exports = __webpack_public_path__ + "img/346.b2f4207d.jpg";